import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from '../../../../autenticacion/servicios/auth.service';
import {ConsumerService} from '../../../recursos/servicio/consumer.service';
import {WebServices} from '../../../recursos/modelo/consumerModel/web-services.enum';
import {UtilConfig} from "../../../../autenticacion/servicios/UtilConfig";
import {Router} from "@angular/router";
import * as moment from "moment";
import {TipoDocumento} from '../../seguridad/emisor/recursos/modelo/tipo-documento.enum';
import {BillingConfiguration} from '../../seguridad/emisor/recursos/modelo/emisor-configuration';
import {Observable} from '../../../../../../node_modules/rxjs/Observable';
import {map, startWith} from 'rxjs/operators';

declare var $: any;
declare var swal: any;

@Component({
    selector: 'app-nota-debito',
    templateUrl: './view/nota-debito.component.html',
    styleUrls: ['./css/nota-debito.component.scss'],
    providers: [AuthService, ConsumerService]
})
export class NotaDebitoComponent implements OnInit {

    @Input() documento;
    IGV = 18.0;
    loading = false;
    loadingConsultas = [
        {
            modulo: "Cargando Series",
            cargando: true
        },
        {
            modulo: "Cargando detalle documento",
            cargando: true
        }
    ];

    mensaje = "";
    error = false;
    formNotaDebito: FormGroup;
    vld_serie: FormControl;
    vld_motivo: FormControl;
    vld_monto: FormControl;
    serie: String;
    tipo: any;
    motivo: String;
    monto: number;
    nota: any;
    tipos = [
        {value: "01", label: 'Intereses por mora'},
        {value: "03", label: 'Penalidades/ otros conceptos'}
    ];
    tipoDoc = "08";
    usuarioSession: any;
    options: String[] = [];
    filteredOptions: Observable<String[]>;
    myControl = new FormControl();


    datosItemSelected: any;
    datosBk: any;
    datoBk: any;
    data: any[] = [];
    dataPreview: any[] = [];
    preview = false;
    receiver: any;
    codCurrency: any;

    constructor(private util: UtilConfig, private fb: FormBuilder, private router: Router, private consumerService: ConsumerService) {
        this.tipo = this.tipos[0];
        this.usuarioSession = this.util.getCurrentUser();
        this.IGV = this.usuarioSession.customer.igv || 18.0;
        this.createFormControls();
        this.createFormNotaDebito();
    }

    ngOnInit(): void {
        this.monto = 0.0;
        this.getSeries();

        this.filteredOptions = this.myControl.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );

        this.getDetalleFactura();
    }

    createFormControls() {
        this.vld_serie = new FormControl({value: ""}, [Validators.required]);
        this.vld_motivo = new FormControl({value: ""}, [Validators.required]);
        this.vld_monto = new FormControl({value: ""}, [Validators.required]);
    }

    createFormNotaDebito() {
        this.formNotaDebito = this.fb.group({
            "serie": this.vld_serie,
            "motivo": this.vld_motivo,
            "monto": this.vld_monto
        });
    }

    onSubmitNotaDebito() {
        this.error = false;
        this.mensaje = "";
        if (this.formNotaDebito.valid) {
            this.generarDocumentoNotaDebito()
        } else {
            swal(
                "Campos obligatorios",
                "Debe completar todo los campos con (*)",
                'error'
            );
        }
    }

    generarDocumentoNotaDebito() {
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        let body = JSON.stringify({
            id: this.documento.id, // id Boleta o Factura
            documentType: this.tipoDoc, // Documento que se va a crear Nota Debito "07" sino Nota Debito "08"
            reason: this.motivo, // Motivo
            typeDebitNote: this.tipo.value, // Por default ahora corresponde a value tipo nota
            codCPE: this.documento.fileName.split("-")[1], // codCPE factura, boleta
            numSerieCPE: this.documento.fileName.split("-")[2], // Serie factura, boleta
            numCPE: this.documento.fileName.split("-")[3], // correlativo factura, boleta
            serieNota: this.serie, // serie de la nota debito
            customer: {
                ruc: this.documento.fileName.split("-")[0]
            },
            amount: this.monto
        });
        this.loading = true;
        this.consumerService.create(WebServices.URL_GENERAR_DOCUMENTOS, body)
            .subscribe(result => {
                console.log(result);
                this.loading = false;
                if (result.codigo != 1) {
                    swal(
                        "No se pudo crear la nota de debito",
                        result.mensaje,
                        'error'
                    );
                } else {
                    swal({
                        title: "Nota de debito creada",
                        text: "Fue creada exitosamente la nota de debito. Refrescando lista.",
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 3000
                    });

                    setTimeout(() => {
                        var filtroList: any = {};
                        var rangeDates: Date[];
                        // RANGO FECHA
                        rangeDates = [new Date(), new Date()];
                        filtroList.tipoFecha = "SUBIDA";
                        filtroList.inicio = moment(rangeDates[0]).format("MM/DD/YYYY");
                        filtroList.fin = moment(rangeDates[1]).format("MM/DD/YYYY");
                        filtroList.documentType = "DEBIT_NOTE";
                        filtroList.estadoRegistro = "TODAS";
                        filtroList.search = '1';
                        $("ul#slide-out").removeClass("open");
                        $("i.cerrarAleta").removeClass("open");
                        $(".closePopupNotaDebito").click();
                        this.router.navigate(['/content', {outlets: {'second': ['logEmisorV2', filtroList]}}]);
                    }, 2000);
                }


            }, err => {
                this.loading = false;
                this.util.abrirModalErrorParaServicios(err, "No se pudo crear el documento", this.router)
            });
    }

    getSeries() {
        let body = JSON.stringify({
            customer: {
                id: this.util.getCurrentUser().customer.id,
                ruc: this.util.getCurrentUser().customer.ruc
            }
        });

        this.loadingConsultas[0].cargando = true;
        this.consumerService.post(WebServices.URL_GET_SERIES, body).subscribe(x => {
            let emisorConfig: BillingConfiguration[] = x["billingConfigurationsList"];
            emisorConfig = emisorConfig.filter(x => x.documentType === TipoDocumento.DEBIT_NOTE);
            emisorConfig = emisorConfig.filter(x => {
                var seAgrega = false;
                // if (this.tipo != TipoNota.ANULACION) {
                if (this.documento.documentType == "TICKET") {
                    if (/^([B][A-Z0-9]{3}|EB01|[0-9]{1,4}|-)$/.test(x.serialNumber.toString())) {
                        seAgrega = true;
                    }
                } else if (this.documento.documentType == "INVOICE") {
                    if (/^([F][A-Z0-9]{3}|E001|[0-9]{1,4}|-)$/.test(x.serialNumber.toString())) {
                        seAgrega = true;
                    }
                }
                return seAgrega;

            });
            if (emisorConfig.length === 0) {
                swal({
                    title: "Obligatorio",
                    text: "Debe configurar al menos una serie para la nota de credito del emisor ",
                    type: 'warning',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 3000
                });
                setTimeout(() => {
                    let filtro: any = {};
                    filtro.busqueda = this.util.getCurrentUser().customer.ruc;
                    $("ul#slide-out").removeClass("open");
                    $("i.cerrarAleta").removeClass("open");
                    $(".closePopupNotaDebito").click();
                    this.router.navigate(['/content', {outlets: {'second': ['emisor', this.util.getCurrentUser().customer.id]}}]);
                }, 3000);
            } else {
                for (let ec of emisorConfig)
                    this.options.push(ec.serialNumber);
                if (this.options.length === 1) {
                    this.vld_serie.setValue(this.options[0]);
                }
            }
            this.loadingConsultas[0].cargando = false;
        }, err => {
            this.loadingConsultas[0].cargando = false;
            this.util.abrirModalErrorParaServicios(err, "Error", this.router)
        });
    }

    pad(num
            :
            Number, size
            :
            number
    ):
        string {
        let s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    getDetalleFactura() {
        let body = {id: this.documento.id};
        this.loadingConsultas[1].cargando = true;
        this.consumerService.post(WebServices.URL_OBTENER_DETALLE, body).subscribe(result => {
            this.data = result["productsStocks"];
            this.receiver = result["receiver"];
            this.codCurrency = result["codCurrency"];
            $.each(this.data, function (pos, item) {
                item.selected = false;
                item.invoicedQuantity = parseFloat(item.invoicedQuantity).toFixed(3);
                item.lineExtensionAmount = parseFloat(item.lineExtensionAmount).toFixed(2);
                item.unitPrice = parseFloat(item.unitPrice).toFixed(2);
            });
            this.datosBk = JSON.parse(JSON.stringify(result["productsStocks"]));
            $.each(this.datosBk, function (pos, item) {
                item.selected = false;
                item.invoicedQuantity = parseFloat(item.invoicedQuantity).toFixed(3);
                item.lineExtensionAmount = parseFloat(item.lineExtensionAmount).toFixed(2);
                item.unitPrice = parseFloat(item.unitPrice).toFixed(2);
            });
            this.loadingConsultas[1].cargando = false;
        }, err => {
            this.loadingConsultas[1].cargando = false;
            this.util.abrirModalErrorParaServicios(err, "Error", this.router)
        });
    }

    private _filter(value
                        :
                        string
    ):
        String[] {
        const filterValue = value.toLowerCase();
        return this.options.filter(option => option.toLowerCase().includes(filterValue));
    }

    generarPreview() {
        this.dataPreview = [];
        this.dataPreview.push({
            productCode: '0000',
            description: this.tipo.label,
            invoicedQuantity: 1,
            measurementUnit: {
                label: 'UND'
            },
            unitPrice: this.monto,
            affectationIGV: 'GRAVADO',
            lineExtensionAmount: this.monto * (this.IGV / 100 + 1)
        });
        this.preview = true;
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/notaDebito/nota-debito.component.ts